import * as React from 'react';
import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TablePagination from '@mui/material/TablePagination';
import TableRow from '@mui/material/TableRow';
import axios from 'axios';
import CircularProgress from '@mui/material/CircularProgress';
import Box from '@mui/material/Box';
import Alert from '@mui/material/Alert';
import TextField from '@mui/material/TextField';
import Link from '@mui/material/Link';
import Button from '@mui/material/Button';
import FacebookIcon from '@mui/icons-material/Facebook';

const columns = [
  { id: 'no', label: 'No', width: '5%' },
  { id: 'uid', label: 'UID', width: '10%' },
  { id: 'server', label: 'Server', width: '10%' },
  { id: 'detail', label: 'Detail', width: 'auto' },
];

function createData(no, uid, server, detail) {
  return { no, uid, server, detail };
}

const GenshinImpact = ( {selectedText} ) => {
  const [searchId, setSearchId] = React.useState('');
  const [data, setData] = React.useState([]);
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(5);
  const [loading, setLoading] = React.useState(false);
  const [error, setError] = React.useState('');
  const [enable] = React.useState(true);

  const handleSearch = React.useCallback(async () => {
    if (!searchId) {
      setError('ID pencarian tidak boleh kosong');
      setData([]);
      return;
    }

    setLoading(true);
    try {
      const response = await axios.get(`${process.env.REACT_APP_API_URL}/game/get?id=${searchId}&game=Genshin Impact`, {
        headers: {
          Authorization: `Bearer ${process.env.REACT_APP_API_KEY}`,
          'Content-Type': 'application/json',
        },
      });

      if (response.data.status === 'success') {
        setData(response.data.data.map((item, index) => createData(index + 1, item.uid, item.server, item.detail)));
        setError('');
      } else {
        setData([]);
        setError(`Data tidak ditemukan untuk ID: ${searchId}`);
      }
    } catch (err) {
      setData([]);
      if (err.response && err.response.data) {
        setError(err.response.data.message);
      } else {
        setError("Terjadi kesalahan saat mencari data");
      }
    } finally {
      setLoading(false);
    }
  }, [searchId]);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  React.useEffect(() => {
    if (searchId.length >= 4) {
      const timeoutId = setTimeout(handleSearch, 1000);
      return () => clearTimeout(timeoutId);
    }
  }, [searchId, handleSearch]);

  const highlightText = (text, highlight) => {
    if (typeof text !== 'string') {
      return null;
    }
  
    // Ganti newline dengan elemen <br>
    const lines = text.split(/(\r\n|\n|\r)/g).map((line, index) => 
      line.match(/(\r\n|\n|\r)/) ? <br key={index} /> : line
    );
  
    // Regex untuk URL
    const urlRegex = /(https?:\/\/[^\s]+)/g;
  
    return lines.map((line, index) =>
      typeof line === 'string' ? (
        line.split(urlRegex).map((part, i) => 
          urlRegex.test(part) ? (
            <Link
              key={`${index}-${i}`}
              href={part}
              target="_blank"
              rel="noopener noreferrer"
              color="inherit"
              underline="always"
            >
              {part}
            </Link>
          ) : highlight ? (
            // Sorot teks yang cocok
            part.split(new RegExp(`(${highlight})`, 'gi')).map((subPart, subIndex) =>
              subPart.toLowerCase() === highlight.toLowerCase() ? (
                <span
                  key={`${index}-${i}-${subIndex}`}
                  className="highlighted-text"
                >
                  {subPart}
                </span>
              ) : (
                subPart
              )
            )
          ) : (
            part
          )
        )
      ) : (
        line
      )
    );
  };

  return (
    <div>
      {!enable ? (
        <>
          <p>Masih disiapkan, kalau kalian ada list uid akun genshin yang ter hb, bisak langsung pm saya di facebook</p>
          <Button
            variant="outlined"
            startIcon={<FacebookIcon />}
            href="https://web.facebook.com/NazwarLancelot"
            target="_blank"
            rel="noopener noreferrer"
          >
            Facebook
          </Button>
        </>
      ) : (
        <>
        <h1>{selectedText || 'Genshin Impact'}</h1>
        <TextField
          label="Masukan UID (min 4 karakter)"
          variant="filled"
          fullWidth
          value={searchId}
          onChange={(e) => setSearchId(e.target.value)}
          sx={{ '& .MuiTextField-root': { m: 1 }, marginBottom: '16px' }}
        />

        {loading && (
          <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', marginBottom: '16px' }}>
            <CircularProgress />
          </Box>
        )}

        {error && <Alert severity="error">{error}</Alert>}

        {data.length > 0 ? (
          <Paper sx={{ width: '100%', overflow: 'hidden' }}>
            <TableContainer sx={{ maxHeight: 440 }}>
              <Table stickyHeader aria-label="sticky table">
                <TableHead>
                  <TableRow>
                    {columns.map((column) => (
                      <TableCell key={column.id} align="left" style={{ width: column.width }}>
                        {column.label}
                      </TableCell>
                    ))}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {data.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((row) => (
                    <TableRow hover role="checkbox" tabIndex={-1} key={`${row.no}-${row.uid}`}>
                      {columns.map((column) => {
                        const value = row[column.id];
                        return (
                          <TableCell key={column.id} align="left">
                            {column.id === 'detail'
                              ? highlightText(value?.toString() || '', searchId)
                              : highlightText(value?.toString() || '', searchId)}
                          </TableCell>
                        );
                      })}
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
            <TablePagination
              rowsPerPageOptions={[5]}
              component="div"
              count={data.length}
              rowsPerPage={rowsPerPage}
              page={page}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
            />
          </Paper>
        ) : (
          <></>
        )}
        </>
      )}
      <div>
        <p>
          <small>
            * Jika ada UID yang belum ter list atau terdaftar bisa langsung pm
            saya di{" "}
            <Link
              href="https://facebook.com/NazwarLancelot"
              target="_blank"
              rel="noopener noreferrer"
              className="text-primary"
            >
              <strong>Facebook</strong>
            </Link>
          </small>
        </p>
        <p>
          <small>
            * Sebagian besar yang sudah ter list atau terdaftar berasal dari
            Facebook{" "}
            <Link
              href="https://facebook.com/profile.php?id=100040755157711"
              target="_blank"
              rel="noopener noreferrer"
              className="text-primary"
            >
              <strong>Muhammad Ilham</strong>
            </Link>{" "}
            di{" "}
            <Link
              href="https://telegra.ph/List-uid-akun-Hbgame-genshin-01-15"
              target="_blank"
              rel="noopener noreferrer"
              className="text-primary"
            >
              <strong>Website</strong>
            </Link>
          </small>
        </p>
      </div>
    </div>
  );
};

export default GenshinImpact;
